import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import detail from '@/views/detail'
import note from '@/views/note'
import introduction from '@/views/introduction'
import message from '@/views/message'
import caipiao from '@/views/caipiao'
import user_login from '@/views/user_login'
import register from '@/views/register'
import login from '@/views/login'
import admin from '@/views/admin'
import myLover from '@/views/myLover'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: introduction
    },
    {
      path: '/note',
      name: 'note',
      component: note
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/caipiao',
      name: 'caipiao',
      component: caipiao
    },
    {
      path: '/user_login',
      name: 'user_login',
      component: user_login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/detail/:id/:type',
      name: 'detail',
      component: detail
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/ffadmin',
      name: 'adminff',
      component: admin
    },
    {
      path: '/myLover',
      name: 'myLover',
      component: myLover
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
      meta: { title: '404' }
    },
    {
			path: '*',
			redirect: '/404'
		}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js